import React, {useEffect, useState, useCallback} from "react";
import {ACTION_PROMPT} from "../../common/const/settings-type";
import SlotSelector from "../../common/components/slot-selector";
import TextBox from "../../../../components/forms/text-box";
import SettingTip from "../../common/components/setting-tip";

function CustomActionSettings({ name, onChangeData, savedSettings, metadata }) {
    const [formData, setFormData] = useState(savedSettings);

    const notifyOnchangeData = data => {
        data.stateType = ACTION_PROMPT
        onChangeData(data);
    }

    useEffect(() => {
        notifyOnchangeData(formData)
    }, [formData]);

    const handleChange = useCallback(event => {
        const { name, value } = event.target;

        setFormData(prevFormData => {
            // if (prevFormData[name] === value) return prevFormData;
            return {
                ...prevFormData,
                [name]: value
            };
        });
    }, []);

    return (
        <div className="flex flex-col gap-2">

            <SettingTip text="Generate answer and assign to Slot based on a prompt that you provide"/>

            <TextBox
                label="Name"
                type="text"
                name="name"
                placeholder="State name"
                value={formData.name}
                onChange={handleChange}
            />

            <TextBox
                label="Action Id"
                type="text"
                name="id"
                placeholder="Enter unique action id"
                value={formData.id}
                onChange={handleChange}
            />

            <SlotSelector 
                title="Slot to Fill"
                value={formData.slotToFill}
                autoFillFromEntity={false} 
                slots={metadata.slots} 
                showCaptureFromUserInput={false}
                onChange={(e)=>handleChange({target: { name: 'slotToFill', value: e.target.value }})} 
                />

            <div className="flex flex-row justify-end">
                <button onClick={()=>{
                    handleChange({target: { name: 'slotToFill', value: undefined }})
                }} className="underline text-xs">Reset Variable Selection</button>
            </div>

        </div>
    )
}

export default CustomActionSettings
